// TODO: https://dev.azure.com/TalentMesh/TalentMesh/_sprints/taskboard/TalentMesh%20Team/TalentMesh/Sprint%2010?workitem=726
export enum AssessmentStatuses {
    Active = 'Active',
    Closed = 'Closed',
}

export function mapAssessmentStatus(value: any): AssessmentStatuses {
    switch (value) {
        case 2:
            return AssessmentStatuses.Active;
        case 3:
            return AssessmentStatuses.Closed;
        default:
            return value as AssessmentStatuses;
    }
}
